import { Link } from "react-router-dom";
import { motion, useReducedMotion } from "framer-motion";
import { HERO_CHIPS, LANDING_COPY, SCENE_HREF } from "@/data/landingContent";
import { PhoneMockup } from "./PhoneMockup";
import { PrimaryCta, SecondaryCta } from "./LandingShared";

export const LandingHero = () => {
  const reduce = useReducedMotion();

  return (
    <section className="container mx-auto px-5 md:px-8">
      <div className="grid items-center gap-12 lg:grid-cols-2 lg:gap-16 lg:pt-4">
        <div className="max-w-xl">
          <motion.p
            className="text-xs font-semibold uppercase tracking-[0.18em] text-neutral-500"
            initial={reduce ? false : { opacity: 0, y: 12 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.45 }}
          >
            {LANDING_COPY.eyebrow}
          </motion.p>
          <motion.h1
            className="mt-4 text-[2.15rem] font-extrabold leading-[1.12] tracking-[-0.04em] sm:text-5xl lg:text-[3.25rem]"
            initial={reduce ? false : { opacity: 0, y: 16 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: reduce ? 0 : 0.08 }}
          >
            <span className="block">{LANDING_COPY.headline[0]}</span>
            <span className="mt-1.5 block">{LANDING_COPY.headline[1]}</span>
            <span className="mt-1.5 block text-blue-600">{LANDING_COPY.headlineAccent}</span>
          </motion.h1>
          <motion.p
            className="mt-5 text-lg leading-relaxed text-neutral-500 md:text-xl"
            initial={reduce ? false : { opacity: 0, y: 14 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: reduce ? 0 : 0.16 }}
          >
            {LANDING_COPY.sub}
          </motion.p>
          <motion.div
            className="mt-8 hidden md:block"
            initial={reduce ? false : { opacity: 0, y: 12 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.45, delay: reduce ? 0 : 0.24 }}
          >
            <div className="flex flex-col gap-3 sm:flex-row sm:items-center">
              <PrimaryCta showMicro={false} />
              <SecondaryCta />
            </div>
            <p className="mt-3 text-sm text-neutral-500">{LANDING_COPY.micro}</p>
          </motion.div>
          <motion.div
            className="mt-8 md:hidden"
            initial={reduce ? false : { opacity: 0, y: 12 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.45, delay: reduce ? 0 : 0.24 }}
          >
            <div className="flex flex-col gap-3">
              <PrimaryCta fullWidth showMicro={false} />
              <SecondaryCta fullWidth />
            </div>
            <p className="mt-3 text-center text-sm text-neutral-500">{LANDING_COPY.micro}</p>
          </motion.div>
        </div>

        <motion.div
          className="relative"
          initial={reduce ? false : { opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.55, delay: reduce ? 0 : 0.18 }}
        >
          <PhoneMockup />
          <ul className="mt-6 flex flex-wrap justify-center gap-2 lg:hidden">
            {HERO_CHIPS.map((chip) => (
              <li
                key={chip.label}
                className="rounded-full border border-neutral-200 bg-white px-3 py-1.5 text-xs font-semibold text-neutral-900"
              >
                {chip.label}
              </li>
            ))}
            <li>
              <Link
                to={SCENE_HREF}
                className="inline-flex rounded-full border border-blue-200 bg-blue-50 px-3 py-1.5 text-xs font-semibold text-blue-600"
              >
                Aeroporto
              </Link>
            </li>
          </ul>
        </motion.div>
      </div>
    </section>
  );
};
